import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import CustomInput from "../Utils/CustomInput2.jsx";
import { Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export default function VulneracionLider({ 
	register, setValue, user, control, errors = {}, useAuth, apiService, Cargando, setCargando, idCabezaFamilia, token, Mensaje
}) {
	const [condicionesMigratorias, setCondicionesMigratorias] = React.useState([]);
	const [rutasActivadas, setRutasActivadas] = React.useState([]);
	const [esquemasSeguridad, setEsquemasSeguridad] = React.useState([]);
	const [perfilesVictima, setPerfilesVictima] = React.useState([]);
	const [tiposQuienBrindaInfo, setTiposQuienBrindaInfo] = React.useState([]);
	const [liderejeliderasgo, setLiderejeliderasgo] = React.useState([]);
	const [liderambitoterritorial, setLiderambitoterritorial] = React.useState([]);
	const [liderrangotiempos, setLiderrangotiempos] = React.useState([]);
	const [lidernropersonasacargo, setLidernropersonasacargo] = React.useState([]);
	const [lidercanalagresion, setLidercanalagresion] = React.useState([]);
	const [liderimpactocomunitario, setLiderimpactocomunitario] = React.useState([]);
	const [lidervinculosistemaalerta, setLidervinculosistemaalerta] = React.useState([]);
	const [liderpsicosocialrequerida, setLiderpsicosocialrequerida] = React.useState([]);

	const ObtenerDatosSelects = async () => {
		let url = `/ddhh/vulneraciones/obtenerdatosselectslideres`;
		try {
			setCargando(true);
			const response = await apiService.get(url, token);
			const result = await response.data;
			setCondicionesMigratorias(result.CondicionMigratoria || []);
			setRutasActivadas(result.RutasActivadas || []);
			setEsquemasSeguridad(result.EsquemasSeguridad || []);
			setPerfilesVictima(result.PerfilesVictima || []);
			setTiposQuienBrindaInfo(result.tiposQuienBrindaInfo || []);
			setLiderejeliderasgo(result.liderejeliderasgo || []);
			setLiderambitoterritorial(result.liderambitoterritorial || []);
			setLiderrangotiempos(result.liderrangotiempos || []);
			setLidernropersonasacargo(result.lidernropersonasacargo || []);
			setLidercanalagresion(result.lidercanalagresion || []);
			setLiderimpactocomunitario(result.liderimpactocomunitario || []);
			setLidervinculosistemaalerta(result.lidervinculosistemaalerta || []);
			setLiderpsicosocialrequerida(result.liderpsicosocialrequerida || []);
		} catch (error) {
			console.error('Error fetching data:', error);
		} finally {
			setCargando(false);
		}
	}
	
	useEffect(() => {
		setValue('datosVulneracion.int_usrid', user);
		setValue('datosVulneracion.dat_fechacreado', new Date().toISOString());
	}, [setValue, user]);
	useEffect(() => {
		ObtenerDatosSelects();
	}, []);
	return (
		<div className="card">
			<div className="card-header">
				<div className="col-md-12">
					<h6 className="text-primary font-weight-bold mb-3">Datos de Lideres</h6>
				</div>
			</div>
			<div className="card-body">
				<div className="row">
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdtipoquienbrindainfo">QUIEN BRINDA INFO</label>
							<select id="datosVulneracion.intIdtipoquienbrindainfo" className="form-control" {...register('datosVulneracion.intIdtipoquienbrindainfo' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {tiposQuienBrindaInfo.map((option, idx) => (
									<option key={option.id} value={option.id}>
										{option.str_nombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdtipoquienbrindainfo && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdcondicionmigratoria">CONDICI&Oacute;N MIGRATORIA</label>
							<select id="datosVulneracion.intIdcondicionmigratoria" className="form-control" {...register('datosVulneracion.intIdcondicionmigratoria' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {condicionesMigratorias.map((option, idx) => (
									<option key={option.id} value={option.id}>
										{option.str_nombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdcondicionmigratoria && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdperfilvictima">PERFIL VICTIMA</label>
							<select id="datosVulneracion.intIdperfilvictima" className="form-control" {...register('datosVulneracion.intIdperfilvictima' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {perfilesVictima.map((option, idx) => (
									<option key={option.id} value={option.id}>
										{option.str_nombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdperfilvictima && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strOtroperfilvictima">OTRO PERFIL VICTIMA. ¿CUAL?</label>
							<input
								id="datosVulneracion.strOtroperfilvictima"
								className="form-control"
								{...register('datosVulneracion.strOtroperfilvictima')}
							/>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intEjeliderazgo">EJE DEL LIDERAZGO</label>
							<select id="datosVulneracion.intEjeliderazgo" className="form-control" {...register('datosVulneracion.intEjeliderazgo' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderejeliderasgo.map((option, idx) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intEjeliderazgo && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intAmbitoterritorial">AMBITO TERRITORIAL DEL LIDERAZGO</label>
							<select id="datosVulneracion.intAmbitoterritorial" className="form-control" {...register('datosVulneracion.intAmbitoterritorial' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderambitoterritorial.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intAmbitoterritorial && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intTiempoejercicioliderazgo">TIEMPO DE EJERCICIO DEL LIDERAZGO</label>
							<select id="datosVulneracion.intTiempoejercicioliderazgo" className="form-control" {...register('datosVulneracion.intTiempoejercicioliderazgo' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderrangotiempos.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intTiempoejercicioliderazgo && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intNropersonascargo">N&Uacute;MERO DE PERSONAS A CARGO</label>
							<select
								id="datosVulneracion.intNropersonascargo"
								className="form-control"
								{...register('datosVulneracion.intNropersonascargo' , { required: true })}
							>
                                <option value="">Seleccione...</option>
                                {lidernropersonasacargo.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intNropersonascargo && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intCanalmedioagresion">CANAL O MEDIO DE LA AGRESI&Oacute;N</label>
							<select id="datosVulneracion.intCanalmedioagresion" className="form-control" {...register('datosVulneracion.intCanalmedioagresion' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {lidercanalagresion.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intCanalmedioagresion && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strOtromedioagresion">OTRO. ¿CU&Aacute;L?</label>
							<input
								type="text"
								maxLength={150}
								id="datosVulneracion.strOtromedioagresion"
								className="form-control"
								{...register('datosVulneracion.strOtromedioagresion')}
							/>
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intImpactolaborcomunitaria">IMPACTO EN LA LABOR COMUNITARIA</label>
							<select id="datosVulneracion.intImpactolaborcomunitaria" className="form-control" {...register('datosVulneracion.intImpactolaborcomunitaria' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderimpactocomunitario.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intImpactolaborcomunitaria && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strOrganizacionpertenece">ORGANIZACI&Oacute;N Y/O ENTIDAD A LA QUE PERTENECE LA PERSONA</label>
							<input
								type="text"
								maxLength={150}
								id="datosVulneracion.strOrganizacionpertenece"
								className="form-control"
								{...register('datosVulneracion.strOrganizacionpertenece')}
							/>
							{errors.datosVulneracion?.strOrganizacionpertenece && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdesquemaseguridad">ESQUEMA DE SEGURIDAD </label>
							<select id="datosVulneracion.intIdesquemaseguridad" className="form-control" {...register('datosVulneracion.intIdesquemaseguridad' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {esquemasSeguridad.map((option, idx) => (
									<option key={option.id} value={option.id}>
										{option.str_nombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdesquemaseguridad && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strCualesquemaseguridad">SI LA RESPUESTA ANTERIOR FUE OTRO ¿CU&Aacute;L?</label>
							<input
								type="text"
								maxLength={150}
								id="datosVulneracion.strCualesquemaseguridad"
								className="form-control"
								{...register('datosVulneracion.strCualesquemaseguridad')}
							/>
							{errors.datosVulneracion?.strCualesquemaseguridad && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.bolAlojamientotransitorio">ALOJAMIENTO TRANSITORIO</label>
							<select
								id="datosVulneracion.bolAlojamientotransitorio"
								className="form-control"
								{...register('datosVulneracion.bolAlojamientotransitorio', {
									setValueAs: (value) => {
										if (value === '') return null;
										return value === 'true';
									}
								})}
							>
								<option value="">Seleccione...</option>
								<option value="true">SI</option>
								<option value="false">NO</option>
							</select>
							{errors.datosVulneracion?.bolAlojamientotransitorio && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intFiscaliageneral">FISCALIA GENERAL DE LA NACI&Oacute;N</label>
							<select id="datosVulneracion.intFiscaliageneral" className="form-control" {...register('datosVulneracion.intFiscaliageneral' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderrangotiempos.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intFiscaliageneral && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intFechadenunciafyn">FECHA DE DENUNCIA EN LA FGN</label>
							<select id="datosVulneracion.intFechadenunciafyn" className="form-control" {...register('datosVulneracion.intFechadenunciafyn' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderrangotiempos.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intFechadenunciafyn && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intSpoa">SPOA</label>
							<select id="datosVulneracion.intSpoa" className="form-control" {...register('datosVulneracion.intSpoa' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderrangotiempos.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intSpoa && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intMinisteriopublico">MINISTERIO P&Uacute;BLICO</label>
							<select id="datosVulneracion.intMinisteriopublico" className="form-control" {...register('datosVulneracion.intMinisteriopublico' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderrangotiempos.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intMinisteriopublico && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intUariv">UARIV</label>
							<select id="datosVulneracion.intUariv" className="form-control" {...register('datosVulneracion.intUariv' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderrangotiempos.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intUariv && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intMevalddhh">MEVAL DDHH</label>
							<select id="datosVulneracion.intMevalddhh" className="form-control" {...register('datosVulneracion.intMevalddhh' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderrangotiempos.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intMevalddhh && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intFechamevalddhh">FECHA RADICADO MEVAL</label>
							<select id="datosVulneracion.intFechamevalddhh" className="form-control" {...register('datosVulneracion.intFechamevalddhh' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderrangotiempos.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intFechamevalddhh && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intConcurrenciagobernacion">CONCURRENCIA GOBERNACI&Oacute;N SI/NO</label>
							<select id="datosVulneracion.intConcurrenciagobernacion" className="form-control" {...register('datosVulneracion.intConcurrenciagobernacion' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderrangotiempos.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intConcurrenciagobernacion && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intFecharadicadogobernacion">FECHA RADICADO GOBERNACI&Oacute;N</label>
							<select id="datosVulneracion.intFecharadicadogobernacion" className="form-control" {...register('datosVulneracion.intFecharadicadogobernacion' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderrangotiempos.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intFecharadicadogobernacion && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intUnp">UNP</label>
							<select id="datosVulneracion.intUnp" className="form-control" {...register('datosVulneracion.intUnp' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderrangotiempos.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intUnp && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intFecharadicadounp">FECHA DE RADICACION UNP</label>
							<select id="datosVulneracion.intFecharadicadounp" className="form-control" {...register('datosVulneracion.intFecharadicadounp' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderrangotiempos.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intFecharadicadounp && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intLinkcarpetausuario">LINK CARPETA POR USUARIO</label>
							<select
								id="datosVulneracion.intLinkcarpetausuario"
								className="form-control"
								{...register('datosVulneracion.intLinkcarpetausuario')}
							>
                                <option value="">Seleccione...</option>
                                {liderrangotiempos.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
							{errors.datosVulneracion?.intLinkcarpetausuario && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intEstadocaso">ESTADO DEL CASO</label>
							<select id="datosVulneracion.intEstadocaso" className="form-control" {...register('datosVulneracion.intEstadocaso' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderrangotiempos.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intEstadocaso && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intVinculadosistemaalertatemprana">VINCULADO A SISTEMA ALERTA TEMPRANA (SAT DEFENSOR&Oacute;A)</label>
							<select id="datosVulneracion.intVinculadosistemaalertatemprana" className="form-control" {...register('datosVulneracion.intVinculadosistemaalertatemprana' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {lidervinculosistemaalerta.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intVinculadosistemaalertatemprana && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intAtencionpsicosocialrequerida">ATENCI&Oacute;N PSICOSOCIAL REQUERIDA / BRINDADA</label>
							<select id="datosVulneracion.intAtencionpsicosocialrequerida" className="form-control" {...register('datosVulneracion.intAtencionpsicosocialrequerida' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {liderpsicosocialrequerida.map((option) => (
									<option key={option.id} value={option.id}>
										{option.strNombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intAtencionpsicosocialrequerida && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
								<label htmlFor="datosVulneracion.datFechacierre">FECHA DE CIERRE </label>
								<Controller
									control={control}
									name="datosVulneracion.datFechacierre"
									rules={{ required: true }}
									render={({ field }) => (
										<DatePicker
											placeholderText="fecha cierre"
											onChange={(date) => field.onChange(date ? new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0] : '')}
											showMonthDropdown
											showYearDropdown
											dropdownMode="select"
											selected={field.value ? new Date(`${field.value}T12:00:00`) : null}
											customInput={<CustomInput />}
											locale="es"
											dateFormat="yyyy-MM-dd"
											maxDate={new Date()}
										/>
									)}
								/>
								{errors.datosVulneracion?.datFechacierre && <span className="text-danger">Este campo es obligatorio</span>}
							</div>
						</div>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strMotivocierre">MOTIVO DE CIERRE </label>
							<input
								type="text"
								maxLength={255}
								id="datosVulneracion.strMotivocierre"
								className="form-control"
								{...register('datosVulneracion.strMotivocierre')}
							/>
							{errors.datosVulneracion?.strMotivocierre && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="datosVulneracion.intIdentidadrelacionddhh">Entidad relacion DDHH</label>
							<select id="datosVulneracion.intIdentidadrelacionddhh" className="form-control" {...register('datosVulneracion.intIdentidadrelacionddhh' , { required: true })}>
                                <option value="">Seleccione...</option>
                                {rutasActivadas.map((option, idx) => (
									<option key={option.id} value={option.id}>
										{option.str_nombre}
									</option>
								))}
                            </select>
                            {errors.datosVulneracion?.intIdentidadrelacionddhh && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
					<div className="col-md-3">
						<div className="form-group">
							<label htmlFor="datosVulneracion.strNrocontacto">Numero de contacto</label>
							<input
								type="text"
								maxLength={80}
								id="datosVulneracion.strNrocontacto"
								className="form-control"
								{...register('datosVulneracion.strNrocontacto')}
							/>
							{errors.datosVulneracion?.strNrocontacto && <span className="text-danger">Este campo es obligatorio</span>}
						</div>
					</div>
				</div>
				<input type="hidden" {...register('datosVulneracion.intUsrid', { valueAsNumber: true })} />
			</div>
		</div>
	);
}

VulneracionLider.propTypes = {
	errors: PropTypes.object,
	personas: PropTypes.array,
	register: PropTypes.func.isRequired,
	setValue: PropTypes.func.isRequired,
	user: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
